import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import styles from './Placeholder.module.css';
import useRenderType from '@Hooks/useRenderType';

const Placeholder = (props) => {
  const { t } = useTranslation();
  const { isSSR } = useRenderType();
  const loadingText = t('ui.bonuses.count');
  return (
    <div
      onClick={() => props.showBouses()}
      className={cn(styles.placeholder, { [styles.underline]: !isSSR })}
      style={{ cursor: 'pointer' }}
      data-testid='coupon-placeholder'
    >
      {isSSR ? loadingText : 'Рассчитать бонусы'}
    </div>
  );
};

export default Placeholder;
